// #region
//  IHT:    Based on react-detect-offline
//          https://github.com/chrisbolin/react-detect-offline
// #endregion
import {
    action,
    extendObservable,
    // toJS,
} from 'mobx';
import { getApiEndpoint } from '../helpers/api';
import { GET_PING } from '../helpers/constants';

export default class ConnectionStore {
    constructor(factory) {
        this.factory = factory;
        this.pollingId = 0;
        this.unsupportedUserAgentsPattern = /Windows.*Chrome/;
        this.config = {
            poll: this.unsupportedUserAgentsPattern.test(navigator.userAgent),
            url: getApiEndpoint(GET_PING),
            timeout: 5000,
            interval: 5000,
        };

        extendObservable(this, {
            isOnline: true,

            setOnlineStatus: action('setOnlineStatus', state => {
                this.isOnline = state;
            }),

            goOnline: () => {
                if (!this.isOnline) {
                    this.setOnlineStatus(true);
                }
            },

            goOffline: () => {
                // console.log("goOffline");
                if (this.isOnline) {
                    this.setOnlineStatus(false);
                }
            },

            checkOnlineStatus: async () => {
                // console.log("checkOnlineStatus", this.config.url);

                if (typeof navigator.onLine === 'boolean' && navigator.onLine) {
                    //if browser thinks it's online, go check the actual connection
                    this.pollingId = this.ping(this.config).then(online => {
                        online ? this.goOnline() : this.goOffline();
                    });
                } else {
                    this.goOffline();
                }
                return this.isOnline;
            },

            pollOnlineStatus: () => {
                setInterval(() => {
                    this.checkOnlineStatus();
                }, this.config.interval);
            },

            stopPolling() {
                clearInterval(this.pollingId);
            },


            ping: config => new Promise((resolve, reject) => {
                const isOnline = () => resolve(true);
                const isOffline = () => resolve(false);

                const xhr = new XMLHttpRequest();

                xhr.onerror = isOffline;
                xhr.ontimeout = isOffline;
                xhr.onload = () => {
                    //const response = xhr.statusText.trim();
                    const response = xhr.status;
                    if (!response) {
                        isOffline();
                    } else {
                        isOnline();
                    }
                };

                xhr.open('GET', config.url);
                xhr.timeout = config.url;
                xhr.send();
            }),
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/ConnectionStore.js